<script>
import { onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useModalStore } from '@/stores/modal.js';

export default {
  setup() {
    // Variables
    const isLoading = ref(true);
    const username = ref(null);

    // I18n
    const { t } = useI18n();

    // Stores
    const modalStore = useModalStore();

    onMounted(async () => { });

    watch(username, (newVal) => {
      if (newVal) {
        modalStore.userEmail = newVal;
      }
    });

    return {
      t,
      isLoading,
      username,
    };
  },
};
</script>

<template>
  <div class="justify-center items-center w-full">
    <div class="px-8 md:px-16 py-4 md:py-8">
      <div class="mb-2">
        <span class="font-bold text-xl">{{ t('modal.forgot_password.modal_body') }}</span>
      </div>
      <div class="mb-4">
        <span class="text-sm">{{ t('modal.forgot_password.modal_body_text') }}</span>
      </div>
      <div>
        <label for="email" class="block text-gray-600 font-semibold">{{ t('modal.forgot_password.email_label') }}</label>
        <input type="email" id="email" name="email" v-model="username" class="w-full mt-1 p-2 px-4 border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-purple-300" :placeholder="t('modal.login.email_placeholder')">
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/styles/components/modals/forgot_password';
</style>
